const sendFormClass: string = "p-talk__input";
const inputClass: string = "c-talk__input--message";
document.addEventListener("submit", async(event: any) => {
  const sendForm: HTMLElement = event.target.closest(`.${sendFormClass}`)!;
  if(sendForm) {
    Send();
    event.preventDefault();
  }
})

const sendForm:HTMLFormElement = document.querySelector(`.${sendFormClass}`)!;
if (sendForm) {
  sendForm.addEventListener("keyup", (event: any) => {
    if (event.keyCode === 13 && event.shiftKey) {
      Send();
      event.preventDefault();
    }
  });
}

const Send = () => {
  const input:HTMLTextAreaElement = document.querySelector(`.${inputClass}`)!;
  const chatBox: HTMLDivElement = document.querySelector(".p-talk__chat")!;
  const inputValue: string = input.value;
  const sendMessage:HTMLElement = MessageTemplate(inputValue);
  chatBox.appendChild(sendMessage);
  const nowChatBox:HTMLElement = document.querySelector(".p-talk__chat")!;
  const bottom: number = nowChatBox.scrollHeight;
  chatBox.scroll({
    top: bottom,
    left: 0,
    behavior: 'smooth'
  })
  Clear(input);
}

const Clear = (input: HTMLTextAreaElement) => {
  input.value = "";
}

const MessageTemplate = (inputValue: string) => {
  const messageTag = document.createElement("p");
  messageTag.classList.add("c-talk__message", "c-talk__message--self");
  messageTag.dataset.date = GetDate();
  messageTag.dataset.time = GetTime();
  messageTag.innerText = inputValue;
  return messageTag;
}

export const GetDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  return `${year}/${month}/${date}`;
}

export const GetTime = () => {
  const now = new Date();
  const hour = now.getHours();
  const min = now.getMinutes();
  return `${hour}:${min}`;
}

//一番下に
window.addEventListener("load", () => {
  const chatBox: HTMLElement = document.querySelector(".p-talk__chat")!;
  if (chatBox) {
    const bottom: number = chatBox.scrollHeight;
    chatBox.scroll({
      top: bottom,
      left: 0,
    })
  }
})
